import {AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';

export function confirmMatchControlsValidator(controlName: string, matchingControlName: string): any{
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
      return;
    }
    (control.value !== matchingControl.value)
      ? matchingControl.setErrors({ confirmedValidator: true })
      : matchingControl.setErrors(null);
  };
}

export function minLengthArray(min: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control instanceof FormArray) {
      return control.length >= min && control.value[0].value ? null : { minLengthArray: true };
    }
    return null;
  };
}

export function arrayNotEmpty(control: AbstractControl): ValidationErrors | null {
  return Array.isArray(control.value) && control.value.length > 0 ? null : { arrayEmpty: true };
}

export function timeRangeValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;

  if (!value) {
    return null;
  }

  const [hoursString, minutesString] = value.split(':');
  const [hours, minutes] = value.split(':').map(Number);
  if (hoursString?.length !== 2 || minutesString?.length !== 2 || hours < 0 || hours > 24 || minutes < 0 || minutes > 59 || (hours === 24 && minutes > 0)) {
    return { invalidTime: true };
  }

  return null;
}
